import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IBasicUserType } from '../../types';

export const StyledIcon = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  opacity: 0;

  svg {
    width: ${rem('14px')};
    height: auto;
  }
`;

export const StyledLabel = styled.label`
  position: relative;
  display: inline-flex;
  padding-top: ${rem('1px')};
  padding-left: ${rem('32px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-flex;
    width: ${rem('24px')};
    height: ${rem('24px')};
    border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
    border-radius: ${rem('4px')};
    vertical-align: top;
    content: '';
  }
`;

export const StyledInput = styled.input<IBasicUserType>`
  position: absolute;
  margin: 0;
  appearance: none;
  opacity: 0;

  &:disabled + ${StyledLabel} {
    cursor: not-allowed;
    opacity: 0.3;

    ${StyledIcon} {
      opacity: inherit;
    }
  }

  &:disabled:not(:checked) + ${StyledLabel} {
    ${StyledIcon} {
      opacity: 0;
    }
  }

  &:not(:disabled):not(:checked) + ${StyledLabel}:hover {
    color: ${({ theme }) => theme.colors.cross.black};
    cursor: pointer;

    &::before {
      border-color: ${({ theme }) => theme.colors.cross.silverFox};
      box-shadow: 0 0 0
        ${({ theme }) =>
          `${rem('2px')} ${rgba(theme.colors.cross.silverFox, 0.2)}`};
    }
  }

  &:not(:disabled):checked {
    & + ${StyledLabel} {
      color: ${({ theme }) => theme.colors.cross.black};
      cursor: pointer;

      ${StyledIcon} {
        opacity: 1;
      }

      &::before {
        border-color: ${({ theme, user }) => user && theme.colors[user].main};
        box-shadow: 0 0 0
          ${({ theme, user }) =>
            user &&
            `${rem('2px')} ${rgba(theme.colors[user].mainAlternate, 0.2)}`};
      }
    }
  }
`;
